/* eslint-disable react/prop-types */
/* global window, document */
import React, {
  useState,
  useEffect,
  useRef,
  Component,
  useContext,
} from "react";

import { NavLink } from "react-router-dom";
import lottie from "lottie-web";

import { withStyles } from "@material-ui/core/styles";
import SearchIcon from "./img/searchIcon.svg";
import ProfileIcon from "./img/3073050-200.png";
import BurgerIcon from "../../img/svg/Burger.svg";
import CloseIcon from "../../img/svg/SchliesszeichenX.svg";
import SucheX from "../../img/svg/Suche_x.svg";
import BookmarkIcon from "../../img/svg/Bookmark.svg";
import logoNeu from "../../img/svg/HdM_Logo_Weiss.svg";
import FilmImage from "../../img/svg/Film.svg";
import CAImage from "../../img/svg/Animationszeichen.svg";
import TVImage from "../../img/svg/TV.svg";
import TonImage from "../../img/svg/ton.svg";
import GameImage from "../../img/svg/Controller.svg";
import StartImage from "../../img/svg/Papierflieger.svg";
import "./Navbar.css";
import ListComponent from "../ListComponent/ListComponent";
import Switch from "../../../node_modules/@material-ui/core/Switch";
import FormGroup from "../../../node_modules/@material-ui/core/FormGroup";
import FormControlLabel from "../../../node_modules/@material-ui/core/FormControlLabel";
import FormControl from "../../../node_modules/@material-ui/core/FormControl";
import { readCookie } from "../../handleCookieData";
import { AddToMyListContext } from "../../context/AddToMyListContext";

const PublicSwitch = withStyles({
  switchBase: {
    color: "#ffffff", // Kreis
    "&$checked": {
      color: "#fff", // Kreis wenn an
    },
    "&$checked + $track": {
      backgroundColor: "#80bb18", // Hintergrund wenn an
    },
  },
  checked: {},
  track: {
    backgroundColor: "#ffffff",
  },
})(Switch);

const Navbar = (props) => {
  /* Nav Scroll Ereignis Hook */
  const [nurOeffentlichState, setNurOeffentlichState] = useState(false);
  const { nurOeffentlichSwitchCallback } = props;
  nurOeffentlichSwitchCallback(nurOeffentlichState);

  const [navBackground, setNavBackground] = useState(false);
  const navRef = useRef();
  navRef.current = navBackground;
  useEffect(() => {
    const handleScroll = () => {
      const show = window.scrollY > 100;
      if (navRef.current !== show) {
        setNavBackground(show);
      }
    };
    document.addEventListener("scroll", handleScroll);
    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const cookieValue =
      readCookie("public_switch_state") == "true" ? true : false;
    setNurOeffentlichState(cookieValue);
  });

  /* lottie load */
  const container = useRef(null);
  useEffect(() => {
    lottie.loadAnimation({
      container: container.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: require("./img/Logo_anim.json"),
    });
  }, []);

  /* ____________________Mobile Browse__________________________ */
  const [showBrowse, setShowBrowse] = useState(false);

  function toggleBrowseModal() {
    if (showBrowse) {
      setShowBrowse(false);
      document.body.style.overflow = "visible";
    } else {
      setShowBrowse(true);
      document.body.style.overflow = "hidden";
    }
  }

  const BrowseMenu = () => (
    <div className="modal-overlay">
      <div className="modal-close-container">
        <button
          className="modal-close-button"
          type="button"
          onClick={() => toggleBrowseModal()}
        >
          <img
            className="modal-close-icon"
            src={CloseIcon}
            width={100}
            alt="Navigation Overlay schließen"
          />
        </button>
      </div>
      <div className="modal-content-container">
        <div className="browse-link-container">
          <a
            href="/mediathek/#hero"
            className="nav-link-mobile"
            activeClassName="nav-link-active"
            onClick={() => toggleBrowseModal()}
          >
            <li>Home</li>
          </a>
          <a
            href="/mediathek/#film"
            className="nav-link-mobile"
            activeClassName="nav-link-active"
            onClick={() => toggleBrowseModal()}
          >
            <li>Filme</li>
          </a>
          <a
            href="/mediathek/#computeranimation"
            className="nav-link-mobile"
            activeClassName="nav-link-active"
            onClick={() => toggleBrowseModal()}
          >
            <li>Animation</li>
          </a>
          <a
            href="/mediathek/#games"
            className="nav-link-mobile"
            activeClassName="nav-link-active"
            onClick={() => toggleBrowseModal()}
          >
            <li>Games</li>
          </a>
          <a
            href="/mediathek/#fernsehsendungen"
            className="nav-link-mobile"
            activeClassName="nav-link-active"
            onClick={() => toggleBrowseModal()}
          >
            <li>TV</li>
          </a>
          <a
            href="/mediathek/#ton"
            className="nav-link-mobile"
            activeClassName="nav-link-active"
            onClick={() => toggleBrowseModal()}
          >
            <li>Ton</li>
          </a>

          {userIsAuthenticated.auth_state <= 0 ? (
            <FormGroup className="public-switch-mobile">
              <FormControl>
                <FormControlLabel
                  checked={
                    readCookie("public_switch_state") == "true" ? true : false
                  }
                  value="end"
                  control={
                    <PublicSwitch onChange={() => toggleSwitchState()} />
                  }
                  label="Nur öffentlich"
                  labelPlacement="end"
                />
              </FormControl>
            </FormGroup>
          ) : null}
        </div>
      </div>
    </div>
  );

  /* ________________________________________Search_________________________________________ */

  // Diese Funktion nimmt den Eingabe Suchstring entgegen und sendet den Ajax Call an den Server

  const [showSearchOverlay, setShowSearchOverlay] = useState(false);

  function toggleSearchModal() {
    if (showSearchOverlay) {
      setShowSearchOverlay(false);
      document.body.style.overflow = "visible";
    } else {
      setShowSearchOverlay(true);
      document.body.style.height = "100vh";
      document.body.style.overflow = "hidden";
    }
  }

  const Searchbar = () => (
    <div style={{ marginLeft: "auto" }}>
      <button
        className="modal-close-button"
        type="button"
        onClick={() => toggleSearchModal()}
      >
        <img
          alt="Suche"
          src={SearchIcon}
          width={100}
          className="nav-search-icon"
        />
      </button>
    </div>
  );

  function SearchOverlay(props) {
    const [searchResults, setSearchResults] = useState([]);
    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState(query);
    const [hasError, setHasError] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedQuery(query);
      }, 300); // 300ms Verzögerung

      return () => {
        clearTimeout(handler);
      };
    }, [query]);

    useEffect(() => {
      fetch(
        `${process.env.REACT_APP_API}/suche/suche?suchtext=${debouncedQuery}`
      )
        .then((response) => response.json())
        .then(
          (result) => {
            setSearchResults(result);
            setIsLoaded(true);
          },
          (error) => setHasError(true)
        );
    }, [debouncedQuery]);

    function passChangedProjectIdToParent(passedID) {
      const { parentCallbackSearch } = props;
      if (parentCallbackSearch) {
        toggleSearchModal();
        parentCallbackSearch(passedID);
      }
    }

    return (
      <div className="modal-overlay">
        <div className="modal-close-container">
          <div>
            <button
              className="modal-close-button"
              onClick={() => toggleSearchModal()}
              type="button"
            >
              <img
                alt="Overlay schließen"
                className="modal-close-icon"
                src={CloseIcon}
                width={100}
              />
            </button>
          </div>
        </div>
        <div className="modal-content-container">
          <div className="search-input-wrapper">
            <input
              className="search-input"
              type="text"
              autoFocus
              placeholder="Titel, Semester, Name"
              onChange={(e) => setQuery(e.target.value)}
              value={query}
            />
            <img
              onClick={() => setQuery("")}
              src={SucheX}
              className="delete-icon"
              aria-label="Suchbegriff löschen"
              alt="Suchbegriff löschen"
            />
          </div>
          <p className="description-text">
            Es wurden {searchResults.length} Suchergebnisse gefunden...
          </p>
          <div className="search-results-container">
            {hasError ? "Fehler bei der Suche..." : null}
            {isLoaded ? (
              <ListComponent
                parentCallback={(value) => passChangedProjectIdToParent(value)}
                isSearch
                searchResults={searchResults}
                displayListButtons={false}
                requestFullAPI={false}
                userAuth={props.userAuthenticated}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }

  function passIDToApp(passedID) {
    const { parentIDCallback } = props;
    if (parentIDCallback) {
      parentIDCallback(passedID);
    }
  }

  function toggleSwitchState() {
    document.cookie = `public_switch_state=${!nurOeffentlichState};max-age=2592000`;
    setNurOeffentlichState(!nurOeffentlichState);
  }

  const { userIsAuthenticated, userName } = props;
  const { currentAnimation } = useContext(AddToMyListContext);
  /* _____________________________________nav return____________________________________________ */
  return (
    <div>
      <nav
        className="nav"
        style={{
          backgroundColor: navBackground ? "rgba(21,21,21,0.5)" : "transparent",
          transition: "1s ease",
          transitionProperty: "background-color", // Transition nur für die Hintergrundfarbe
          zIndex: 200, // z-Index hinzugefügt, damit die Nav Bar beim Scrollen die Module der Hauptseite
        }}
      >
        <div className="nav-links-list">
          <div className="nav-links-smallView">
            <img
              className="nav-burger-icon"
              src={BurgerIcon}
              height={100}
              alt="Navigation Menü"
              aria-label="Seitennavigation Menü"
              tabIndex={0}
              onKeyDown={(e) =>
                e.key === "Enter" ? toggleBrowseModal() : null
              }
              onClick={() => toggleBrowseModal()}
            />
          </div>
          <a href="/mediathek/#hero" aria-label="HdM Mediathek Logo">
            <div className="nav-logo">
              {" "}
              <img
                className="mediathek-logo"
                src={logoNeu}
                alt="Logo"
                width={100}
              />
            </div>
          </a>
          <div className="nav-links-largeView">
            <a
              href="/mediathek/#hero"
              className="nav-link"
              activeclassname="nav-link-active"
              tabIndex={0}
            >
              <img className="nav-link-icon" src={StartImage} alt="Home" />
              <li>Home</li>
            </a>
            <a
              href="/mediathek/#film"
              className="nav-link"
              activeclassname="nav-link-active"
              tabIndex={0}
            >
              <img className="nav-link-icon" src={FilmImage} alt="Film" />
              <li>Filme</li>
            </a>
            <a
              href="/mediathek/#computeranimation"
              className="nav-link"
              activeclassname="nav-link-active"
              tabIndex={0}
            >
              <img
                className="nav-link-icon"
                src={CAImage}
                alt="Computeranimation"
              />
              <li>Animation</li>
            </a>
            <a
              href="/mediathek/#games"
              className="nav-link"
              activeclassname="nav-link-active"
              tabIndex={0}
            >
              <img className="nav-link-icon" src={GameImage} alt="Games" />
              <li>Games</li>
            </a>
            <a
              href="/mediathek/#ton"
              className="nav-link"
              activeclassname="nav-link-active"
              tabIndex={0}
            >
              <img className="nav-link-icon" src={TonImage} alt="Ton" />
              <li>Ton</li>
            </a>
            <a
              href="/mediathek/#fernsehsendungen"
              className="nav-link"
              activeclassname="nav-link-active"
              tabIndex={0}
            >
              <img className="nav-link-icon" src={TVImage} alt="TV" />
              <li>TV</li>
            </a>
          </div>

          <Searchbar />
          <div className="nav-links-largeView">
            {userIsAuthenticated.auth_state <= 0 ? (
              <FormGroup className="public-switch">
                <FormControl>
                  <FormControlLabel
                    checked={
                      readCookie("public_switch_state") == "true" ? true : false
                    }
                    value="end"
                    control={
                      <PublicSwitch onChange={() => toggleSwitchState()} />
                    }
                    label="Nur öffentlich"
                    labelPlacement="end"
                  />
                </FormControl>
              </FormGroup>
            ) : null}
          </div>
          <NavLink exact to="/mediathek/favorites">
            <img
              className="nav-bookmark-icon"
              src={BookmarkIcon}
              heigth={100}
              alt="Zu meiner Liste"
              aria-label="Zu meiner Liste"
              tabIndex={0}
              style={currentAnimation}
            />
          </NavLink>

          {userIsAuthenticated.auth_state > 0 ? (
            <a
              href="https://www.hdm-stuttgart.de/mediathek/logout"
              className="profile-icon-container"
            >
              <button className="logout-button">
                <img
                  style={{ filter: "invert(100%) opacity(0.3)" }}
                  className="nav-profile-icon"
                  src={ProfileIcon}
                  height={100}
                  alt="Login"
                  aria-label="Login"
                />
                <p className="nav-username">{"Hallo, " + userName}</p>
              </button>
            </a>
          ) : (
            <a
              href={`https://www.hdm-stuttgart.de/mediathek/login?currentURL=${window.location.href}`}
            >
              <button className="login-button">
                <img
                  style={{ filter: "invert(100%) opacity(0.3)" }}
                  className="nav-profile-icon"
                  src={ProfileIcon}
                  height={100}
                  alt="Login"
                  aria-label="Login"
                />
                {window.innerWidth > 424 ? (
                  <p className="login-label">ANMELDEN</p>
                ) : null}
              </button>
            </a>
          )}
        </div>
      </nav>
      {showBrowse ? <BrowseMenu /> : null}
      {showSearchOverlay ? (
        <SearchOverlay
          userAuthenticated={userIsAuthenticated.auth_state}
          parentCallbackSearch={(value) => passIDToApp(value)}
        />
      ) : null}
    </div>
  );
};

export default Navbar;
